import { Block } from 'baseui/block';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { JobCore } from '../../types/jobs';
import { JobDetailData } from './JobDetailData';

type Props = {
  job: JobCore;
};
function JobCardBody({ job }: Readonly<Props>) {
  const { css, theme } = useStyles();

  return (
    <Block
      className={css({
        padding: theme.sizing.scale400,
      })}
    >
      <JobDetailData job={job} />
    </Block>
  );
}

export default memo(JobCardBody);
